module.exports = __webpack_public_path__ + "static/media/Inter-Regular.4105c0d1.woff2";